import { Delays } from '../../../entities/exercise/delays';
import { Exercise } from '../../../entities/exercise/exercise';
import { WorkoutSettings } from '../../../entities/user/workoutsettings';
import { IAudioTip, SessionSequenceEntry } from '../../../entities/workoutsession/sessionsequenceentry';
import { UserExerciseSession } from '../../../entities/workoutsession/userexercisesession';

export interface IMotiTipStrategy {
    assignVoiceTips(
        entry: SessionSequenceEntry,
        session: UserExerciseSession,
        settings: WorkoutSettings,
        motiTips: { Q1: Exercise[] | undefined; Q2: Exercise[] | undefined; Q3: Exercise[] | undefined },
        isStreamingWorkout: boolean,
    ): SessionSequenceEntry;
}
export class MotiTipContext {
    private strategy: IMotiTipStrategy;

    constructor(strategy: IMotiTipStrategy) {
        this.strategy = strategy;
    }

    public useStrategy(
        entry: SessionSequenceEntry,
        session: UserExerciseSession,
        settings: WorkoutSettings,
        motiTips: { Q1: Exercise[] | undefined; Q2: Exercise[] | undefined; Q3: Exercise[] | undefined },
        isStreamingWorkout: boolean,
    ): SessionSequenceEntry {
        return this.strategy.assignVoiceTips(entry, session, settings, motiTips, isStreamingWorkout);
    }
}

const getInstructorVoiceTip = (id: string, workoutSettings?: WorkoutSettings) => {
    return workoutSettings && workoutSettings.homeWorkoutInstructor ?
      `${id}_${workoutSettings.homeWorkoutInstructor}` : id;
};

export const assignForRest = (
    id: string,
    audioTips: IAudioTip[],
    voiceTipDelays: Delays,
    settings: WorkoutSettings) => {
    if (voiceTipDelays.restTipDelay) {
        audioTips = [
            ...audioTips, {
                fileName: getInstructorVoiceTip(id, settings),
                delay: voiceTipDelays.restTipDelay,
            }];
    }
    return audioTips;
};
